import React from 'react'

function validmail() {
    const params=window.location.href.split("?");
fetch("/validmail",{
          method:"POST",
          headers:{
              "content-type": "application/json"
          },
          body:JSON.stringify(params),
          }) 
          .then((res) => res.json())
          .then((res)=>{
            if(res.isToken){
            window.location="/login";
            }else{
            window.location="/";
            }
          })   
  return (
    <div>validmail</div>
  )
}

export default validmail